var map = {
	"./1.jpg": 7363,
	"./2.jpg": 3964,
	"./3.jpg": 6031,
	"./4.jpg": 5741,
	"./aboutus.png": 1565,
	"./aboutus/00 PREVIEW - ABOUT US-01.jpg": 9203,
	"./aboutus/SECTION01.png": 5567,
	"./aboutus/SECTION02.png": 7392,
	"./aboutus/SECTION02_old.png": 2925,
	"./aboutus/SECTION02_old2.png": 9655,
	"./aboutus/SECTION03.png": 8841,
	"./aboutus/SECTION04.png": 3655,
	"./aboutus/SECTION05.png": 9964,
	"./aboutus/SECTION06.png": 2182,
	"./aboutus/SECTION07.png": 6792,
	"./aboutus/SECTION08.png": 5833,
	"./aboutus/SECTION09.png": 1836,
	"./aboutus/SECTION10.png": 2233,
	"./alllogo.png": 3829,
	"./alllogo1.png": 5112,
	"./alllogo2.png": 5364,
	"./alllogo3.png": 5506,
	"./alllogo4.png": 870,
	"./bgshape.png": 6335,
	"./bgshape.svg": 5179,
	"./brand/1.png": 725,
	"./brand/10.png": 7327,
	"./brand/11.png": 1851,
	"./brand/12.png": 1036,
	"./brand/1t.png": 4807,
	"./brand/2.png": 2149,
	"./brand/2t.png": 2361,
	"./brand/3.png": 9411,
	"./brand/3t.png": 8945,
	"./brand/4.png": 6078,
	"./brand/4t.png": 7500,
	"./brand/5.png": 2334,
	"./brand/5t.png": 4777,
	"./brand/6.png": 553,
	"./brand/6t.png": 4169,
	"./brand/7.png": 4045,
	"./brand/7t.png": 9171,
	"./brand/8.png": 8388,
	"./brand/8t.png": 3599,
	"./brand/9.png": 9724,
	"./brand/9t.png": 5205,
	"./client/1.jpg": 9233,
	"./client/1.png": 935,
	"./client/2.jpg": 2294,
	"./client/2.png": 5611,
	"./client/3.jpg": 5215,
	"./client/3.png": 5479,
	"./client/4.jpg": 225,
	"./client/4.png": 7752,
	"./client/5.png": 9945,
	"./client/6.png": 8523,
	"./client/7.png": 1977,
	"./client/8.png": 9905,
	"./cloud.svg": 5977,
	"./cludeicon.png": 1921,
	"./common.png": 9923,
	"./commoncontact.png": 5858,
	"./commondns.png": 6063,
	"./commonssl.png": 778,
	"./commonvps.png": 5825,
	"./data.png": 7892,
	"./dc.png": 1275,
	"./dhost.svg": 4337,
	"./discount_offers/card-title-old.png": 458,
	"./discount_offers/card-title.png": 6012,
	"./discount_offers/cloud-storage-icon.png": 887,
	"./discount_offers/cpanel-logo.png": 2936,
	"./discount_offers/domain-icon.png": 9953,
	"./discount_offers/hero-banner.png": 8446,
	"./discount_offers/hero-banner.webp": 527,
	"./discount_offers/new_year_2024.png": 1818,
	"./discount_offers/sixth_december.png": 2411,
	"./discount_offers/victory-day.png": 8526,
	"./discount_offers/victory-day.webp": 7577,
	"./discount_offers/vps-icon.png": 9073,
	"./discount_offers/youth-illustration.png": 3656,
	"./discount_offers/youth-offer-text.png": 8543,
	"./discount_offers/youth-section.png": 5498,
	"./domain1.png": 1674,
	"./domain2.png": 7368,
	"./domain3.png": 9139,
	"./domain4.png": 471,
	"./domain5.png": 8685,
	"./domain6.png": 4427,
	"./fast.png": 3701,
	"./fast.svg": 5979,
	"./favicon.png": 4184,
	"./featured-img1.jpg": 8908,
	"./featured-img2.jpg": 4538,
	"./featured-img3.jpg": 4954,
	"./featured-img4.jpg": 281,
	"./footer-logo.png": 7917,
	"./ggmap.png": 627,
	"./headphone.svg": 2786,
	"./hero-3.png": 229,
	"./hero-bg.svg": 4632,
	"./lock.png": 8066,
	"./logo.png": 5080,
	"./logo1.png": 1369,
	"./logo1_old.png": 976,
	"./logo_old.png": 1992,
	"./mainserver.png": 7679,
	"./mainserver1.png": 1310,
	"./map.png": 8034,
	"./map_old.png": 8554,
	"./network.svg": 4063,
	"./p1.svg": 7317,
	"./p2.svg": 1271,
	"./p3.svg": 9158,
	"./review.png": 9424,
	"./section-icon.png": 2330,
	"./services-2/antivirus.png": 7426,
	"./services-2/backup.png": 9415,
	"./services-2/boost.png": 5540,
	"./services-2/database.png": 2878,
	"./services-2/desktop.png": 1549,
	"./services-2/encryption.png": 5954,
	"./services-2/fast.png": 9122,
	"./services-2/network.png": 853,
	"./services-2/privacy.png": 7957,
	"./services-2/ransomware.png": 7951,
	"./services-2/secure.png": 9183,
	"./services-2/setup.png": 8788,
	"./services-2/ssl.png": 2375,
	"./services-2/textsearch.png": 7756,
	"./services/backup.png": 583,
	"./services/boost.png": 7179,
	"./services/database.png": 4740,
	"./services/fast.png": 5536,
	"./services/fback.png": 739,
	"./services/fdata.png": 6973,
	"./services/feasy.png": 6192,
	"./services/ffast.png": 2571,
	"./services/fpp.png": 3891,
	"./services/fssl.png": 6576,
	"./services/idea.png": 4103,
	"./services/network.png": 4637,
	"./services/privacy.png": 1141,
	"./services/q1.png": 9578,
	"./services/setup.png": 945,
	"./services/ssd.png": 3564,
	"./services/ssl-Improved-seo.jpg": 2572,
	"./services/ssl-address-bar-visibility.jpg": 3300,
	"./services/ssl-boost-credibility.jpg": 5594,
	"./services/ssl-extended-validation.jpg": 3582,
	"./services/ssl-guaranteed-security.jpg": 4649,
	"./services/ssl-secure-all-sub-domains.jpg": 882,
	"./services/ssl-strongest-encryption.jpg": 4405,
	"./services/ssl-trustLogo-site-seal.jpg": 4546,
	"./services/ssl.png": 333,
	"./services/support.png": 3517,
	"./services/wp.png": 9590,
	"./shape/1.png": 8620,
	"./shape/10.png": 3660,
	"./shape/11.png": 7246,
	"./shape/12.png": 8292,
	"./shape/13.png": 5553,
	"./shape/14.png": 1072,
	"./shape/15.png": 5796,
	"./shape/16.png": 7721,
	"./shape/17.png": 1323,
	"./shape/2.png": 8085,
	"./shape/3.png": 9459,
	"./shape/4.png": 60,
	"./shape/5.png": 1299,
	"./shape/6.png": 3546,
	"./shape/7.png": 3823,
	"./shape/8.png": 4702,
	"./shape/9.png": 4911,
	"./shape/card-shape.png": 2283,
	"./shape/circle.png": 8839,
	"./shared.png": 2905,
	"./sign.png": 1355,
	"./skills/Asset4.png": 7175,
	"./skills/Asset5.png": 5394,
	"./skills/Asset6.png": 7588,
	"./skills/Asset7.png": 1702,
	"./skills/Asset8.png": 6454,
	"./skills/Asset9.png": 3818,
	"./skills/BACKGROUND-01.jpg": 2919,
	"./skills/PREVIEW-01.jpg": 3251,
	"./slider1.png": 371,
	"./slider11.png": 4990,
	"./slider123.png": 817,
	"./slider2.png": 9958,
	"./slider22.png": 4893,
	"./slider234.png": 2098,
	"./slider3.png": 1059,
	"./ssl-Improved-seo.jpg": 4544,
	"./ssl-address-bar-visibility.jpg": 5589,
	"./ssl-boost-credibility.jpg": 5700,
	"./ssl-certificate.gif": 8011,
	"./ssl-extended-validation.jpg": 5501,
	"./ssl-guaranteed-security.jpg": 9834,
	"./ssl-secure-all-sub-domains.jpg": 8555,
	"./ssl-strongest-encryption.jpg": 446,
	"./ssl-trustLogo-site-seal.jpg": 1464,
	"./storage.png": 8192,
	"./tech/1.png": 3114,
	"./tech/10.png": 8357,
	"./tech/11.png": 1161,
	"./tech/12.png": 9461,
	"./tech/13.png": 1481,
	"./tech/14.png": 604,
	"./tech/2.png": 5946,
	"./tech/3.png": 8792,
	"./tech/4.png": 9043,
	"./tech/5.png": 4673,
	"./tech/6.png": 7378,
	"./tech/7.png": 7493,
	"./tech/8.png": 1150,
	"./tech/9.png": 6417,
	"./whyuschose/6REASONSLICE.png": 3259,
	"./whyuschose/BACKGROUND(1894x1829).jpg": 7839,
	"./whyuschose/PREVIEWWHYCHOOSEUS-01.jpg": 7651,
	"./whyuschose/TICKSIGN.png": 4277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;